import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from "react-select";


export const SearchableSelectField = ({ label, id, options, value, onChange, disabled }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    if(value){
      setSearchQuery(options.filter(option => option.value === value))
    }
  },[options, value])

  // Include a placeholder option
  const filteredOptions = [
    { label: 'Select an option', value: null, image: '' },
    ...options
  ];

  const handleOptionSelect = (selectedOption) => {
    onChange(selectedOption?.value);
    setSearchQuery(selectedOption); // Set search query to a selected option
  };

  return (
    <div className="mb-3 position-relative" ref={dropdownRef}>
      <label htmlFor={id} className="form-label fw-medium">
        {label}
      </label>
      <div className="input-group">

        <Select
          className=" show w-100"
          options={filteredOptions}
          value={searchQuery}
          onChange={handleOptionSelect}
          disabled={disabled}
        />
      </div>

    </div>
  );
};